/**
 * Domain validation rules for inline editing
 *
 * Provides centralized validation logic that can be reused across
 * all inline edit components. All predicates are pure functions.
 */
export const ValidationRules = {
  /**
   * Check if a string value is empty (null, undefined, or only whitespace)
   */
  isEmpty: (value: string | null | undefined): boolean => {
    return !value || value.trim() === '';
  },

  /**
   * Check if a string value exceeds the maximum allowed length
   */
  exceedsMaxLength: (value: string, maxLength: number): boolean => {
    return value.length > maxLength;
  },

  /**
   * Check if a string value is valid (not empty and within max length)
   */
  isValid: (value: string, maxLength: number): boolean => {
    return !ValidationRules.isEmpty(value) && !ValidationRules.exceedsMaxLength(value, maxLength);
  },
};
